import React, { type ReactElement } from 'react';

import { ProButton } from '@components/Button/variants';
import IconQuote from '@components/Images/Rebranding/IconQuote';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { QUOTE } from './constants';
import { ClusterQuoteProps } from './interfaces';

const ClusterQuote = ({ proOfferCode, upgradePath }: ClusterQuoteProps): ReactElement => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.Quote,
  });
  const { person, personTitle, quote } = QUOTE;

  const handleUpgradeClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.Upgrade, offerCode: proOfferCode }));
  };

  return (
    <figure className="m-0 mt-48 sm:mt-64 sm:px-48">
      <div className="sm:flex sm:flex-row sm:flex-nowrap sm:items-start sm:justify-center sm:gap-24">
        <IconQuote className="w-64 text-grayscale-beige sm:shrink-0" />
        <blockquote className="m-0 mt-16 sm:mt-0 sm:max-w-[520px] md:max-w-[620px]">
          <p className="mb-0 mt-8 font-suisse-works text-headline-xxs sm:mt-0 md:text-headline-xs">
            {quote}
          </p>
          <figcaption className="m-0 mt-8 font-suisse-screen text-caption-md font-normal text-grayscale-charcoal">
            <span className="font-bold">&mdash; {person}</span>, {personTitle}
          </figcaption>
        </blockquote>
      </div>
      <ProButton
        as="link"
        className="mt-32 sm:mx-auto sm:mt-48 sm:max-w-[330px]"
        href={upgradePath}
        onClickCapture={handleUpgradeClick}
        fullWidth
      >
        Upgrade
      </ProButton>
    </figure>
  );
};

export default ClusterQuote;
